<template lang="pug">
  //- ルート一覧の表示
  #route-list-container
    div.text-center(v-if="falseInfo")
      .my-5 情報の取得に失敗しました
      buttom.my-2(@click.prevent="$router.go(-1)" style="cursor: pointer; color:blue") 前のページに戻る
    div(v-if="!falseInfo")
      div(v-if="!isLoading")
        //-ページング
        #rock-paging
          .pager(@click="callPaging('before')" v-bind:disabled="isLoading" :class="{isPagerActive:!isFirstRock}")
            i.fas.fa-chevron-left &nbsp前の岩
          .pager(@click="callPaging('next')" v-bind:disabled="isLoading" :class="{isPagerActive:!isLastRock}")
            |次の岩&nbsp 
            i.fas.fa-chevron-right
      .spinner.text-center(v-if="isLoading")
        b-spinner.mt-5.mb-5(variant="primary" label="Loading..." )
      div(v-if="!isLoading")
        //-岩名
        #rock-name
          #name {{this.rockName}}
          #count(v-if="targetRockRouteList.length > 0") {{targetRockRouteList.length}}ルート
        //- 未ログイン時の表示↓↓↓↓↓--------------------------
        #overlay-wrapper(v-if="(isLogin == false && isDemoLocky == false && !isLoading) || (isLogin == true && $user.payment == null && isDemoLocky == false && !isLoading) ")
          #overlay
            #info-area.mt-3.pt-5
              |この続きは有料プラン限定機能です。
              |<br>有料プランにご登録頂きますと、<br>岩場情報やルート写真の参照、<br>登攀記録の作成が可能になります。
              |<br>
              span 有料プラン（月額）は初月無料！
            #button-area.pl-3.pr-3
              //- ログイン済み、且つ、無料会員の場合
              div(v-if="isLogin")
                button.btn.btn-primary(@click="callRouterPush('/user/payment/add_input')") 有料プランお申込み
              //- 未ログインの場合
              div(v-else)
                button.btn.btn-primary(@click="callRouterPush('/register_user/send_auth')") 新規ユーザー登録
                button.btn.btn-primary.btn-sm(@click="callRouterPush('/login')" v-if="!isLogin") ログインはこちら
        //- 未ログイン時の表示↑↑↑↑↑--------------------------
        //- ルートListとルート画像
        #rock-detail(v-if="(isDemoLocky == true && !isLoading) || (isLogin == true && $user.payment != null && !isLoading) ")
          //- PC表示の場合の切り替えボタン
          .d-none.d-md-block
            .row
              .col-12.col-md-6
                button.btn.btn-secondary.mb-3.mr-3.mr-md-3.float-right(v-if='is3DModelExists && !isOnsight' type='button' @click='change3DFlag') 
                  span {{getButtonLabel()}}
          .row
            .col-12.col-md-6.order-md-2
              //- 特記事項
              #route-info(v-if="remarkList.length>0")
                .info(v-for="info in this.remarkList")
                  i.fas.fa-info-circle 
                  |{{info}}
              //- ルートList
              #all-route-list(:style="{maxHeight:routeListMaxHeight}")
                #list-innner
                  .list-row(
                    v-for="route in targetRockRouteList" 
                    @click="listRouteSelect(route)"  
                    :class="{listRowActive:route.routeId == routeId , listRowImgNotExists: (route.img =='' && isAllRouteNoImgInRock)|| !route.isRouteLineExists }"
                  )
                    .list-route-name.ml-2 {{route.routeName}}
                    .list-record.ml-2
                      .badge.climbKind.p-2(:class="{'badge-primary': route.topClimbKindNum!='4', 'badge-secondary': route.topClimbKindNum=='4'}") {{ route.topClimbKind }}
                    .list-level(v-if="!isOnsight") {{route.level}}
                    .inner-box
                      router-link(:to="{ name: 'record_edit', query: { rockyId:rockyId, rockId:rockId, routeId:route.routeId, ref:'routeId'}}")
                        i.fas.fa-edit
                    .inner-box(v-if="!isLikeLoading&&isLogin" @click.stop="like(route, $user)" style="color: #004170")
                      i.fas.fa-thumbs-up(v-if="isLiked(rockId, route.routeId, $user.userId)")  {{ likedNum(route.routeId) }}
                      i.fas.fa-thumbs-up(v-else style="color: #9b9b9b")  {{ likedNum(route.routeId) }}
                    .spinner-border.spinner-border-sm.text-success(v-if="isLikeLoading" :disabled="true")
              //- リスト拡張表示
              #list-expansion.text-right(v-if="isListExpandedShow & !isAllRouteNoImgInRock" @click="expandList()")
                i.fas.fa-caret-down(v-if="!isListExpanded")
                i.fas.fa-caret-up(v-if="isListExpanded")
                |  {{expandListMessage}}
            //- モバイル表示の場合の切り替えボタン
            .d-md-none.d-block.col-12.float-right
              button.btn.btn-secondary.mb-3.mr-3.mr-md-3.float-right(v-if='is3DModelExists && !isOnsight' type='button' @click='change3DFlag') 
                span {{getButtonLabel()}}

            .col-12.col-md-6.order-md-1
              //- ルート画像が存在しない場合
              #rock-img-default(v-if='isAllRouteNoImgInRock')
                img(:src="makeImgPath(ROCK_DEFAULT_IMG_PATH)" alt='')
              //- ルート画像が存在する
              #rock-img(v-if='!isAllRouteNoImgInRock')
                //- ルート名、レベル
                #svg-header(v-if='!isOnsight') {{imgHeaderName}}  {{imgHeaderLvl}}  <small> {{imgHeaderAdditionalInfo}} </small>
                #svg-header(v-else) {{imgHeaderName}} <small> {{imgHeaderAdditionalInfo}} </small>
                #rock-img-svg-container
                  //-ルート画像
                  #svg-wrapper(v-if='currentDispMode=="2D" || !is3DModelExists && currentDispMode=="3D"')
                    svg(id="srcSvg")
                      image(id="svg-box-img" x='0' y='0' :href='makeImgPath(svgImgPath)')
                      //- オンサイトスタイルでは画像以外描画しない
                      template(v-if='!isOnsight' v-for="record in this.convertedCurrentRouteList")
                        template(v-for="start in record.startCoordinate")
                          //- スタートマーク
                          ellipse(
                            :cx="start[0]"
                            :cy="start[1]"
                            :rx="start[2]"
                            :ry="start[2]"
                            :style="{strokeWidth: start[3]}"
                            stroke="#0596ff"
                            fill="none"
                            :class="{strokeActive :record.routeId == routeId, strokeInActive : record.routeId != routeId}"

                          )
                          //- スタートマーク
                          ellipse.coverPolyline(
                            :cx="start[0]"
                            :cy="start[1]"
                            :rx="start[2]"
                            :ry="start[2]"
                            stroke="rgba(255,255,255,0)"
                            fill="none"
                            @click="svgPolylineClick(record.routeId)"
                          )
                        //- 1つのルートに複数ルート線が存在する場合があるので、ループ処理
                        template(v-for="route in record.routeCoordinate")
                          //- ルート線
                          polyline(
                            :points= 'route'
                            marker-start='url(#maerker1)'
                            fill='none'
                            stroke-linecap='round'
                            pointer-events="auto"
                            :id = "record.routeId"
                            :class="{strokeActive :record.routeId == routeId, strokeInActive : record.routeId != routeId}"
                          )
                          //- クリック領域を広めるための、透明の要素
                          polyline.coverPolyline(
                            :points= 'route'
                            stroke= 'rgba(255,255,255,0)'
                            stroke-width= '40'
                            marker-start='url(#maerker1)' 
                            fill='none'
                            stroke-linecap='round'
                            pointer-events="auto"
                            :id = "record.routeId"
                            @click="svgPolylineClick(record.routeId)"
                          )
                  //-3Dモデル表示
                  .model-viewer-box(v-if='is3DModelExists && currentDispMode=="3D"')
                    //- サムネイル表示
                    .thumbnail(v-if="!isCalled3DModel" @click.prevent="show3DModel()")
                      img(:src="modelThumbPath", alt="")
                      p 3D View
                      i.fas.fa-play-circle
                    //- 3Dモデル
                    .model-box(v-if="isCalled3DModel")
                      model-viewer#rock3DModel(
                        bounds="tight", 
                        enable-pan, 
                        :src="modelPath", 
                        ar, 
                        ar-modes="webxr scene-viewer quick-look", 
                        camera-controls, 
                        environment-image="neutral", 
                        :poster= "modelLoadingPath",
                        loading="eager",
                        shadow-intensity="1")
                        //ルート線のラベル
                        template(v-for="(item,index) in modelDetailList" :value="item")
                          button.routeLabel(
                            :id= "'modelLabel_' + item.routeId",
                            :slot="'hotspot-' + index", 
                            :data-position="item.dataPosition", 
                            :data-normal="item.dataNormal", 
                            data-visibility-attribute="visible"
                            @click="modelRouteSelect(item.routeId)")
                            .routeAnnotation {{item.routeName}}
                        .progress-bar.hide(slot="progress-bar")
                          .update-bar
                  //-ルート線のページング
                  #route-arrow-box-left
                    .arrow(@click="callRoutePaging('before')" :class="{isRouteArrowActive:!isFirstRouteInImgExistList}")
                      i.fas.fa-caret-left
                  #route-arrow-box-right
                    .arrow(@click="callRoutePaging('next')" :class="{isRouteArrowActive:!isLastRouteInImgExistList}")
                      i.fas.fa-caret-right

                //- ルート画像カルーセル
                carousel.mt-3(
                  v-if="isShowDrawRouteButton && currentDispMode=='2D'"
                  v-bind:per-page-custom=[[100,3],[768,7]]
                  :navigation-enabled="false"
                  :pagination-enabled="false"
                  navigation-prev-label="〈"
                  navigation-next-label="〉"
                  :speed="1000"
                )
                  slide(v-for="record in this.carouselRockImgList" :class="{currentImg:record.isCurrent}")
                    img.slider-inner(:src="makeImgThumbPath(record.img)" alt="" @click="changeImg(record)")

                #list-button-container
                  //- ルート表示ボタン
                  #draw-route-button-area(v-if="isShowDrawRouteButton && currentDispMode=='2D'")
                    //- オンサイト重視OFF
                    b-button.button-blue#draw-route-button(v-if="!isOnsight" @click="switchDrawRoute()") 
                      div(v-if="isShowingRouteLine")
                        |ルート線を非表示にする
                      div(v-else)
                        |ルート線を表示する
                    //- オンサイト重視ON ダイアログ出力
                    b-button.button-blue(v-if="isOnsight" v-b-modal.onsight-info)
                      | ルート線を表示する
                    b-modal#onsight-info(ok-only)
                      p オンサイト重視の設定ではライン表示は切替できません。
                        |<br>マイページ→プロフィール編集から設定を変更できます。

</template>

<script>
import Loading from '@/components/Loading.vue'
import { Carousel, Slide } from 'vue-carousel'
import axios from 'axios'

export default {
  // データオブジェクト
  data() {
    return {
      rockyId:null,
      rockId:null,
      routeId:null,
      rockyName:'',
      rockName:'',
      targetRockRouteList:[],
      targetRockRouteExistImgList:[],
      routeCoordinateList:[],
      remarkList:[],
      likedRoutes: [],
      userLiked:[],
      currentDispRouteImg:'',
      isAllRouteNoImgInRock:false,
      isAllRouteNoCoordinateInRock:false,
      ROUTE_LIST_HEIGHT_MIN:'30vh',
      ROUTE_LIST_HEIGHT_MAX:'200vh',
      routeListMaxHeight:'',
      expandListMessage:'',
      EXPAND_LIST_MESSAGE_OPEN:'リストを開く',
      EXPAND_LIST_MESSAGE_CLOSE:'リストを閉じる',
      isListExpandedShow:false,
      isListExpanded:false,
      //表示制御フラグ(権限)
      isLogin:false,
      isDemoLocky:false,
      //表示制御フラグ(loading関連)
      isLoading:false,
      isLikeLoading:false,
      //表示制御フラグ(3D-model)
      is3DModelExists:false,
      currentDispMode:"2D",
      MODE_2D:"2D",
      MODE_3D:"3D", 
      //ページング
      isFirstRock:false,
      isLastRock:false,
      //ルートページング
      isFirstRouteInImgExistList:false,
      isLastRouteInImgExistList:false,
      currentDispRouteId:'',
      //ルート画像
      ROCK_DEFAULT_IMG_PATH :'/img/rk/no_img.png',
      isDataExist:false,
      carouselRockImgList: [],
      imgHeaderLvl:'',
      imgHeaderName:'',      
      imgHeaderAdditionalInfo:'',
      IMG_HEADER_ADDITIONAL_INFO:'- 画像のみ表示 -',
      // ルート線表示・非表示のフラグ
      isShowDrawRouteButton:true,
      isShowingRouteLine: true,
      isOnsight: false,
      //エラー制御
      falseInfo: false,
      //岩画像SVG
      svgImgPath:'',
      convertedCurrentRouteList:[],
      svgContainerHeight: '0px',
      routeHighlightCoordinate:'',
      //3Dモデル
      isCalled3DModel:false,
      modelPath:'',
      modelThumbPath:'',
      modelLoadingPath:'',
      modelDetailList:[]
    }
  },
  // コンポーネント
  components: {
    Carousel,
    Loading,
    Slide
  },
  created() {
    this.createdProcess()
  },
  async mounted() {
    //windowサイズの変更イベントを追加
    window.addEventListener('resize', this.handleResize)
    if(this.isLogin) {
      this.likedRoutes = await this.getLikedNum(this.$route.params.rockId, this.$user)
      this.userLiked = await this.getUserLiked(this.$user)
    }
  },
  beforeDestroy() {
    //windowサイズの変更イベントを削除
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    /**
     * ルートIDのルートのいいね数を取得する
     */
    likedNum() {
      return (routeId) => {
        let result = this.likedRoutes.filter(n => {
          return n.routeId == routeId
        })
        var count = 0
        if(result.length > 0) {
          let val = result[0]
          count = val.likeCount
        }
        return count
      }
    },
    /**
     * いいね判定
     */
    isLiked() {
      return (rockId, routeId, userId) => {
        /**
         * userIdの完全一致とrockRouteIdの岩ID前方一致(例："999-")で取得し、
         * いいね済みかの色分け判断にルートID部を利用する
         */
        let targetRoute = this.userLiked.filter(n => {
          if( n.userId === userId && !n.rockRouteId.indexOf(rockId.toString())) {
            let arr = n.rockRouteId.split("-")
            return (arr[1] == routeId)
          }
        })
        return targetRoute.length > 0 ? true : false
      }
    }
  },
  watch: {
    $route(to, from) {
      this.isAllRouteNoImgInRock = false
      this.remarkList = []
      this.createdProcess()
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next()
    if(this.isLogin) {
      this.likedRoutes = await this.getLikedNum(this.$route.params.rockId, this.$user)
      this.userLiked = await this.getUserLiked(this.$user)
    }
  },
  // メソッド
  methods: {
    
    //3Dモデル情報取得
    async get3dModel() {

      const jsonUrl = process.env.VUE_APP_API_GATEWAY + "/api-search-rocky/vr-model"
      const params = {
        rockId: this.rockId
      }
      try {
        const response = await axios.get(jsonUrl, {
          params: params,
          headers: {
            'Authorization': this.$user.idToken
          }
        })

        //初期化
        this.isCalled3DModel = false
        this.is3DModelExists = false
        //3Dモデルが存在する場合
        if(response.data.length > 0){
          this.is3DModelExists = true

          //ルート名をセットしながら、3Dモデル用のリストを作成する
          response.data[0].modelInfoList.forEach(info => {

            let route = this.targetRockRouteList.filter(n => {
              return n.routeId == info.routeId
            })

            let routeName = route[0].routeName == '（ルート名無し）' ? 'ルート名無し': route[0].routeName         

            this.modelDetailList.push({
              routeId: info.routeId,
              dataPosition: info.dataPosition,
              dataNormal: info.dataNormal,
              cameraOrbit: info.cameraOrbit,
              routeName: routeName
            })
          })
          
          var S3_BASE_PATH = process.env.VUE_APP_MATERIAL_URL
          this.modelPath = S3_BASE_PATH + response.data[0].modelPath
          this.modelThumbPath = S3_BASE_PATH + response.data[0].thumbPath
          this.modelLoadingPath = S3_BASE_PATH + "/img/model/loading-mini.gif" 

        }

        //3D表示を利用したことのあるユーザーの場合、
        //前回の利用モードを適用する。
        if(localStorage.is3DModelDisp == undefined){
          localStorage.is3DModelDisp = "false"
          this.currentDispMode = this.MODE_2D
        }else if(localStorage.is3DModelDisp == "true" && this.is3DModelExists && !this.isOnsight){
          this.currentDispMode = this.MODE_3D
        }else{
          this.currentDispMode = this.MODE_2D
        }

        return response.data
      } catch(error) {
        return error
      }
    },
    getCameraOrbit(){
      const modelViewer = document.querySelector("model-viewer#rock3DModel");
      var orbit = modelViewer.getCameraOrbit();
      //$theta $phi $radius
      var wkObit = orbit.theta + " " + orbit.phi + " " + orbit.radius
    },
    show3DModel(){
      //3Dモデルを表示する
      this.isCalled3DModel = true
    },
    //3Dモデルのハイライト処理
    changeModelRouteHighlight(routeId){
      //3Dモデルを表示している場合のみ処理する
      if(!this.isCalled3DModel){
        return
      }
      //カメラ位置変更
      this.changeCameraPosition(routeId)
      //ラベルの背景色変更
      this.changeModelLableColor(routeId)
    },
    //3Dモデル内のカメラ位置を変更する
    changeCameraPosition(routeId){
      //routeIdに紐付くデータをListから抽出する
      var wkList = this.modelDetailList.filter(item => item.routeId == routeId)
      if(wkList.length==0){
        return
      }
      //カメラ位置変更
      var item = wkList[0]
      const modelViewer = document.querySelector("model-viewer#rock3DModel")
      //TODO:必要に応じてコメント解除
      //modelViewer.cameraTarget = item.cameraTarget
      //modelViewer.fieldOfView = item.fieldOfView
      if(modelViewer == null) return;
      modelViewer.cameraOrbit = item.cameraOrbit
    },
    changeModelLableColor(routeId){      
      //一旦すべてのラベルの背景色をリセットする
      this.modelDetailList.forEach((item) => {
        var wkId = "modelLabel_" + item.routeId
        var wkEl = document.getElementById(wkId)
        if(wkEl){
          wkEl.style.background = "rgba(0,0,0,0.6)"
        }
      })
      var targetId = "modelLabel_" + routeId
      var targetEL = document.getElementById(targetId)
      if(targetEL){
        targetEL.style.background = "#0491ff99" 
      } 
    },
    /**
     * いいね数といいねの状況を制御する
     */
    async like(paramRockInfo, paramUserInfo) {
      this.isLikeLoading = true
      const jsonUrl = process.env.VUE_APP_API_GATEWAY + "/api-like"
      const headers = {
          'Authorization': paramUserInfo.idToken
        }
      const rockId = this.$route.params.rockId
      const params = {
        rockId: rockId,
        routeId: paramRockInfo.routeId,
        rockRouteId: `${rockId}-${paramRockInfo.routeId}`,
        userId: paramUserInfo.userId,
        isLogin: paramUserInfo.isLogin
      }
      try {
        let count = await this.likedNum(paramRockInfo.routeId)
        let isLiked = this.isLiked(rockId, paramRockInfo.routeId, paramUserInfo.userId)
        // いいねが既にある かつ 自分がいいね済み
        if(count > 0 && isLiked) {
          await axios.delete(jsonUrl, {params: params, headers: headers})
        // いいねが既にある かつ 自分が未いいね
        } else if(count > 0 && !isLiked){
          await axios.post(jsonUrl, params, {headers: headers})
        // いいねがまだない or いいね数0だが履歴は存在する
        } else {
          await axios.post(jsonUrl, params, {headers: headers})
        }
        this.likedRoutes = await this.getLikedNum(this.$route.params.rockId, this.$user)
        this.userLiked = await this.getUserLiked(this.$user)
        this.isLikeLoading = false
      } catch(error) {
        return error
      }
    },
    /**
     * いいねをつけたユーザを取得する
     */
    async getUserLiked(paramUserInfo) {
      const jsonUrl = process.env.VUE_APP_API_GATEWAY + "/api-like"
      const params = {
        tableName: "userLike",
        userId: paramUserInfo.userId,
        isLogin: paramUserInfo.isLogin
      }
      try {
        const response = await axios.get(jsonUrl, {
          params: params,
          headers: {
            'Authorization': paramUserInfo.idToken
          }
        })
        return response.data.Items
      } catch(error) {
        return error
      }
    },
    /**
     * 各ルートのいいね数を取得する
     */
    async getLikedNum(rockId, paramUserInfo) {
      const jsonUrl = process.env.VUE_APP_API_GATEWAY + "/api-like"
      const params = {
        rockId: rockId,
        tableName: "routeLike",
        userId: paramUserInfo.userId,
        isLogin: paramUserInfo.isLogin
      }
      try {
        const response = await axios.get(jsonUrl, {
          params: params,
          headers: {
            'Authorization': paramUserInfo.idToken
          }
        })
        return response.data.Items
      } catch(error) {
        return error
      }
    },
    /*--------------------------
      created時の処理
    --------------------------*/ 
    async createdProcess(){

      this.rockyId = this.$route.params.rockyId
      this.rockId = this.$route.params.rockId
      this.isLogin = this.$user.isLogin
      this.isOnsight = this.$user.onsight

      //直接アクセス等で親画面のデータが空の場合、親画面のcreate処理を実行する
      if(this.$parent.rockyMasterData == null || this.$parent.rockList == null){
        await this.$parent.createdProcess()
      }

      //岩一覧画面を経由していない場合の対策
      if(this.$route.params.rockName == undefined){
        this.rockName = this.$parent.rockList.filter(rock => rock.id == this.rockId)[0].name
      }else{
        this.rockName = this.$route.params.rockName
      }

      //パンくずリストの値を設定
      this.$parent.rockName = this.rockName

      //デモ表示用岩場の場合はルートを表示する
      if(this.rockyId == process.env.VUE_APP_DEMO_ROCKY_ID){
        this.isDemoLocky = true 
      }

      //未登録または無料会員がデモ岩場以外を表示しようとした場合は処理終了
      if(this.$user.payment == null && !this.isDemoLocky){
        return
      }

      //List拡張の初期化
      this.isListExpandedShow = false
      this.expandListInit()

      //ページング処理
      this.updatePagerFlag()

      //ルートList,ルート座標Listの取得
      await this.getAndSetRouteList()

      //岩の中に画像が1枚もない場合、ルートListの高さ制限を解除する
      if(this.isAllRouteNoImgInRock){
        this.routeListMaxHeight= this.ROUTE_LIST_HEIGHT_MAX
      }else{
        this.routeListMaxHeight= this.ROUTE_LIST_HEIGHT_MIN
      }

      //PC表示の場合、リストは開いた状態にする
      if(window.outerWidth > 992){
        this.isListExpandedShow = false
        this.routeListMaxHeight = this.ROUTE_LIST_HEIGHT_MAX
      }else{
        //ルートListにスクロールが必要な場合、拡張ボタンを表示する
        if(this.targetRockRouteList.length > 6){
          this.isListExpandedShow = true
        }
      }

      /**
       * ルート一覧のルート名で遷移した場合
       * 岩画像上でルートをハイライトする
       */
      if(this.$route.params.routeId !== undefined) {
        let target = this.targetRockRouteList.filter(n => {
          return n.routeId == this.$route.params.routeId
        })
        if(target.length) {
          await this.listRouteSelect(target[0])
        }
      }

      //3Dモデル取得処理
      await this.get3dModel()

      //画像がある場合、描画する
      if(!this.isAllRouteNoImgInRock){
        //画像とルート線の表示
        this.dispRockImgAndRouteLine()
        this.svgPolylineClick(this.routeId)
      }

      this.isLoading = false
    },

    /*--------------------------
      画像とルート線の表示
      このメソッドが呼ばれる前に、currentDispRouteImg、currentRouteListが
      更新されていることが前提。
    --------------------------*/  
    async dispRockImgAndRouteLine(){

      //表示対象の岩画像をセット
      this.svgImgPath = this.currentDispRouteImg

      let isVertical = false
      isVertical = await this.getIsVertical()

      let el = document.getElementById('rock-img-svg-container')
      let clientWidth = el.clientWidth

      let srcSvgEl = document.getElementById('srcSvg')
      srcSvgEl.style.width = clientWidth
      
      let imgEl = document.getElementById('svg-box-img')
      imgEl.style.width = clientWidth
      
      let scale = 1
      const ORG_IMG_WIDTH = 1280
      const ORG_IMG_VERTICAL = 960 

      if(!isVertical){
        //横画像の場合
        srcSvgEl.style.height = clientWidth * 0.75
        //元画像のサイズから表示倍率を算出する
        scale = ORG_IMG_WIDTH / clientWidth
      }else{
        //縦画像の場合
        srcSvgEl.style.height = clientWidth * 1.35
        //元画像のサイズから表示倍率を算出する
        scale = ORG_IMG_VERTICAL / clientWidth
      }

      // SVGのPolylineで表示できるように、現行の座標情報を変換する
      this.convertedCurrentRouteList = []

      for(let i = 0; i < this.currentRouteList.length; i++){

        let item = this.currentRouteList[i]

        //後続の処理の準備
        //1ルートに複数ルート線紐付くデータの対応。
        //ルート線1本ずつ区切ったListに変換する。
        let wkList = []
        if(item.routeCoordinate != null){

          let routeCoordinateList = item.routeCoordinate.split(']],[[');

          routeCoordinateList.forEach((route) => {
            wkList.push(this.convertCoordinate(route,scale));
          })
        }

        // スタートマークの描画
        let stList = []
        if(item.startCoordinate != null) {
          // 座標のみを抽出([]の中身のみ抽出で繰り返しマッチ)
          let params = item.startCoordinate.match(/(?:\[).*?(?=\])/g)
          // スタートの座標のみを取得する
          for (const param of params) {
            // ごみ取り
            let temp = param.replace('[', '');
            temp = temp.replace('[', '')
            let startParam = temp.split(',');
            //画像のサイズに合うように座標データに縮尺を反映する
            let x = String(Math.floor(parseInt(startParam[0]) / scale))
            let y = String(Math.floor(parseInt(startParam[1]) / scale))
            stList.push([x, y, startParam[2], startParam[3]])
          }
        }

        let wkObj = {
          routeId : item.routeId,
          labelCoordinate : item.labelCoordinate,
          routeCoordinate : wkList,
          startCoordinate: stList,
          remarks : item.remarks,
        }
        this.convertedCurrentRouteList.push(wkObj)
      }
      
      if(!this.isAllRouteNoCoordinateInRock){
        this.isShowDrawRouteButton = false
      }

    },
    /*----------------------------------
      画像の向きが縦向きかどうか判定して返す
    -----------------------------------*/
    getIsVertical(){
      let imgPath = this.makeImgPath(this.svgImgPath)

      return new Promise(function (resolve, reject) {
        let img = new Image()
        img.onload = function() {
          //画像のオリジナルサイズ
          let orgWidth = img.width
          let orgHeight = img.height
          let letFlg  = false
          if(orgHeight > orgWidth){
            letFlg =  true
          }
          resolve(letFlg);
        }
        img.src = imgPath
      });

    },
    /*----------------------------------
      canvas用の座標をSVG用に変換して返す
    -----------------------------------*/
    convertCoordinate(param,scale){

      if(param == null){
        return
      }
      //座標情報が文字列としてセットされているので、
      //後続の処理に不要な要素を取り除く
      param = param.replace( '[[[', '[' )
      param = param.replace( ']]]', ']' )
      let ary = param.split('],[')
      let returnStr = ""

      for (let i in ary){
        let wkItemList = ary[i].split(',')
        let x = wkItemList[0].replace( '[', '' )
        let y = wkItemList[1].replace( ']', '' )
        //画像のサイズに合うように座標データに縮尺を反映する
        x = String(Math.floor(parseInt(x)/scale))
        y = String(Math.floor(parseInt(y)/scale))

        if(i == 0){
          returnStr += x + ' ' + y
        }else{
          returnStr += ',' + x + ' ' + y
        }
      }
      return returnStr

    },
    /*--------------------------
      3Dモデル上のルートを選択
    --------------------------*/ 
    async modelRouteSelect(routeId){
      let param = this.targetRockRouteList.filter(rt => rt.routeId == routeId)[0]
      this.listRouteSelect(param)
    },
    /*--------------------------
      一覧上のルートを選択
    --------------------------*/ 
    async listRouteSelect(param){

      //ルートの画像がない場合は終了
      if(param == undefined || param.img == ''){
        return
      }

      //選択中のルートを更新
      this.routeId = param.routeId

      //svg上のページャー更新
      this.updateRoutePagerFlag()

      //選択したルートと同じ画像が紐付くルートを抽出する
      let wkCurrentCoordinateList = this.routeCoordinateList.filter(rt => rt.img == param.img)[0].coordinateList
      
      //画像とルート線表示用のデータを更新する
      this.currentDispRouteImg = param.img
      this.currentRouteList = wkCurrentCoordinateList

      //画像とルート線の表示(3Dモードの場合は処理しない)
      if(this.currentDispMode == "2D") this.dispRockImgAndRouteLine()

      //特記事項のセット
      let wkRemarkList = []
      this.remarkList = []
      for(let i = 0; i < wkCurrentCoordinateList.length; i++){
        let item = wkCurrentCoordinateList[i]
        if(item.remarks != undefined){
          wkRemarkList.push(item.remarks)
        }
      }
      this.remarkList = wkRemarkList

      //カルーセル画像Listのフラグ更新
      this.updateCarouselRockImgListFlg()

      //ルート線のハイライト
      this.svgPolylineClick(this.routeId)

      //3Dモデルのハイライト処理
      this.changeModelRouteHighlight(this.routeId)
    },
    /*--------------------------
      ルート線のハイライト処理
    --------------------------*/ 
    async svgPolylineClick(routeId){

      this.imgHeaderName = ''
      this.imgHeaderLvl = ''
      this.imgHeaderAdditionalInfo = ''

      this.isShowingRouteLine = true

      this.routeId = routeId      
      let wkObj = this.targetRockRouteList.filter(rt => rt.routeId == routeId)[0]

      this.imgHeaderName = wkObj.routeName
      this.imgHeaderLvl = '（ ' + wkObj.level + ' ）'

      if(!wkObj.isRouteLineExists){
        this.imgHeaderAdditionalInfo = this.IMG_HEADER_ADDITIONAL_INFO
      }

      //svg上のページャー更新
      this.updateRoutePagerFlag()

      //3Dモデルのハイライト処理
      this.changeModelRouteHighlight(routeId)
    },
    /*--------------------------
      カルーセルで画像選択した際の処理
    --------------------------*/ 
    async changeImg(param){

      this.currentDispRouteImg = param.img

      //選択した画像に紐付く座標情報を抽出
      let wkCoordinateList = this.routeCoordinateList.filter(rt => rt.img == this.currentDispRouteImg)[0].coordinateList
      //同一の画像内で1ルート目をハイライト対象とする
      let wkCoordinate = wkCoordinateList[0]

      let wkTargetRoute = this.targetRockRouteList.filter(rt => rt.routeId == wkCoordinate.routeId)[0]

      const wkObj = {
        'routeId':wkCoordinate.routeId,
        'level':wkTargetRoute.level,
        'routeAuthor':'',
        'routeName':wkTargetRoute.routeName,
        'img':param.img,
        'isRouteActive': true,
        'no':1,
      }

      this.listRouteSelect(wkObj)

      //カルーセル画像Listのフラグ更新
      this.updateCarouselRockImgListFlg()
    },

    /*--------------------------
      カルーセル画像List更新
    --------------------------*/ 
    updateCarouselRockImgListFlg(){
      //カルーセルの画像Listのcurrentフラグを切り替える
      let wkList = []
      for (let i = 0; i < this.carouselRockImgList.length; i++) {
        let wkObj = this.carouselRockImgList[i]
        wkList.push({
          'img':wkObj.img,
          'coordinateList':wkObj.coordinateList,
          'isCurrent': this.currentDispRouteImg == wkObj.img ? true:false
        })
      }
      this.carouselRockImgList = wkList
    },
    //---------------
    // 岩場データ取得
    //---------------
    getRockyMasterData: (paramRockyId,isLogin) => new Promise((resolve, reject) => {
      const jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-search-rocky/rocky-info?rockyId=' + paramRockyId + '&isLogin=' + isLogin
      axios.get(jsonUrl)
      .then(res => resolve(res))
      .catch(err => reject(err))
    }),
    //------------------------------
    //  ルートList取得
    //------------------------------
    getRouteListData: (rockId, rockyId, user) => new Promise((resolve, reject) => {
      const jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-search-rocky/route-list_v2'
      axios.get(jsonUrl, {
        params: {
          "rockId": rockId,
          "rockyId": rockyId
        },
        headers: {
          'Authorization': user.isLogin ? user.idToken : 'no-login'
        }
      })
      .then(res => resolve(res))
      .catch(err => reject(err))
    }), 
    //----------------------------
    //  ルート座標データを取得する
    //----------------------------
    getRouteCoordinateList: (rockId) => new Promise((resolve, reject) => {
      let query = '?rockId=' + rockId
      const jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-search-rocky/route-coordinate-list' + query
      axios.get(jsonUrl)
      .then(res => resolve(res))
      .catch(err => reject(err))
    }),
    /*--------------------------
      岩ページング
    --------------------------*/ 
    async callPaging(flg){

      //岩場内で先頭の岩、末尾の岩の場合returnする。
      if(flg == 'before'){
        if(this.isFirstRock){
          return
        }
      }else{
        if(this.isLastRock){
          return
        }
      }
      
      //次の岩の読み込みのため、loading状態にする
      this.isLoading = true

      //親コンポーネントの岩Listを利用する
      const pagingRockIdList = this.$parent.rockList

      //遷移先のrockIdを抽出する
      //現在のrockIdの要素番号を抽出する
      let wkCnt = 0
      for(let i = 0; i < pagingRockIdList.length; i++){
        if(pagingRockIdList[i].id == this.rockId){
          break
        }
        wkCnt ++
      }

      //遷移先のrockIdを抽出する
      let nextRockObj = {}
      if(flg == 'before'){
        nextRockObj = pagingRockIdList[wkCnt-1]
      }else{
        nextRockObj = pagingRockIdList[wkCnt+1]
      }

      let nextRockId = nextRockObj.id
      let nextRockName = nextRockObj.name

      //次の岩を表示する
      this.$router.push(
        { 
          name: 'rockyInfo_:rockyId_:rockId',
          params: {
            rockyId: this.rockyId, 
            rockId: nextRockId,
            rockName:nextRockName,
            rockyMasterData:this.$parent.rockyMasterData,
          }
        },() => {},() => {})

      return

    },
    /*--------------------------
      ページング関連の更新処理
    --------------------------*/ 
    updatePagerFlag(){

      //親コンポーネントの岩Listを利用する
      const pagingRockIdList = this.$parent.rockList

      //初期化
      this.isFirstRock = false
      this.isLastRock = false

      //表示対象の岩が岩場で最初or最後であるかチェックしてフラグを更新する
      for(let i = 0; i < pagingRockIdList.length; i++){
        if(pagingRockIdList[i].id == this.rockId){
          //対象の岩が岩内で最初の場合
          if(i == 0){
            this.isFirstRock = true
          }
          //対象の岩が岩内で最後の場合
          if(i == pagingRockIdList.length - 1 ){
            this.isLastRock = true
          }
          break
        }
      }

    },
    /*--------------------------
      ルート遷移(画像上のページング)
    --------------------------*/     
    callRoutePaging(flg){

      //岩内で先頭のルート、末尾のルートの場合returnする。
      if(flg == 'before'){
        if(this.isFirstRouteInImgExistList){
          return
        }
      }else{
        if(this.isLastRouteInImgExistList){
          return
        }
      }

      //遷移先のrouteIdを抽出する
      //現在のrouteIdの要素番号を抽出する
      let wkCnt = 0
      for(let i = 0; i < this.targetRockRouteExistImgList.length; i++){
        if(this.targetRockRouteExistImgList[i].routeId == this.routeId){
          break
        }
        wkCnt ++
      }

      //遷移先のrockIdを抽出する
      let nextRouteObj = {}
      if(flg == 'before'){
        nextRouteObj = this.targetRockRouteExistImgList[wkCnt-1]
      }else{
        nextRouteObj = this.targetRockRouteExistImgList[wkCnt+1]
      }

      //遷移先のルートを表示
      this.listRouteSelect(nextRouteObj)

      return
    },
    /*--------------------------
      ルートページングのフラグ処理
    --------------------------*/ 
    updateRoutePagerFlag(){

      //初期化
      this.isFirstRouteInImgExistList = false
      this.isLastRouteInImgExistList = false

      for(let i = 0; i < this.targetRockRouteExistImgList.length; i++){

        if(this.targetRockRouteExistImgList[i].routeId == this.routeId){
          //対象の岩が岩内で最初の場合
          if(i == 0){
            this.isFirstRouteInImgExistList = true
          }
          //対象の岩が岩内で最後の場合
          if(i == this.targetRockRouteExistImgList.length - 1 ){
            this.isLastRouteInImgExistList = true
          }
          break
        }
      }
    },
    /*--------------------------
      Listの拡張、縮小
    --------------------------*/ 
    expandList(){
      if(this.routeListMaxHeight == this.ROUTE_LIST_HEIGHT_MAX){
        this.expandListInit()
      }else{
        this.routeListMaxHeight = this.ROUTE_LIST_HEIGHT_MAX
        this.expandListMessage = this.EXPAND_LIST_MESSAGE_CLOSE
        this.isListExpanded = true
      }
    },
    expandListInit(){
      this.routeListMaxHeight = this.ROUTE_LIST_HEIGHT_MIN
      this.expandListMessage = this.EXPAND_LIST_MESSAGE_OPEN
      this.isListExpanded = false
    },
    /*----------------------------------------
      windowサイズが変更されたら実行される処理
    -----------------------------------------*/
    handleResize(){
      //画像がある場合、描画する
      if(!this.isAllRouteNoImgInRock){
        //画像とルート線の表示
        this.dispRockImgAndRouteLine()
        this.svgPolylineClick(this.routeId)
      }
    },
    //---------------------
    // ルート情報の取得処理
    //---------------------
    async getAndSetRouteList(){

      if((this.isLogin == false && this.isDemoLocky == false) || 
        (this.isLogin == true && this.$user.payment == null && this.isDemoLocky == false)){
        return
      }

      //ルートテーブルを取得する
      let wkDbRouteList = []
      await this.getRouteListData(this.rockId, this.rockyId, this.$user)
      .then(response => {
        wkDbRouteList = response.data
      })
      .catch(function (error) {
        console.log(error)
        console.log('getRouteListData() error')
        this.falseInfo = true
      })

      //表示中のデータを初期化
      this.targetRockRouteList = []
      this.targetRockRouteExistImgList = []
      this.routeCoordinateList = []

      //ルート座標テーブルを取得する
      let json = await this.getRouteCoordinateList(this.rockId)
      this.routeCoordinateList = json.data

      //取得した画面内で利用するルートListにセットする
      let count = 0
      wkDbRouteList.forEach((route) => {
        let wkImg = ''
        let isRouteLineExists = false

        for(let i=0; i<this.routeCoordinateList.length;i++) {
          for(let j=0; j<this.routeCoordinateList[i].coordinateList.length ;j++) {
            if(this.routeCoordinateList[i].coordinateList[j].routeId == route.routeId){
              wkImg = this.routeCoordinateList[i].img

              //ルート線の座標データ有無をセットする
              if(this.routeCoordinateList[i].coordinateList[j].routeCoordinate != null){
                isRouteLineExists = true
                this.isAllRouteNoCoordinateInRock = true
              }
            }
          }
        }
        var topClimbKind = ""
        switch (route.topClimbKind) {
          case "1":
            topClimbKind = "オ"
            break;
          case "2":
            topClimbKind = "フ"
            break;
          case "3":
            topClimbKind = "完"
            break;
          case "4":
            topClimbKind = "ト"
            break;
          default:
            topClimbKind = ""
            break;
        }

        this.targetRockRouteList.push({
          no: ++count,
          routeId: route.routeId,
          routeName: this.cnvRouteName(route.routeName),
          level: route.gradeName,
          routeAuthor: '',
          img:wkImg,
          isRouteLineExists:isRouteLineExists,
          topClimbKind: topClimbKind,
          topClimbKindNum: route.topClimbKind,
        })
      })

      if(this.routeCoordinateList.length==0){
        //岩内に撮影済みのルートが1件もない場合、ここまで
        this.isAllRouteNoImgInRock = true
        return
      }

      //初期表示のルートは画像が存在るすルートのうち、routeIdが一番若いものとする
      this.targetRockRouteExistImgList = this.targetRockRouteList.filter(rt => rt.img != "")

      let wkCurrentRoute = this.targetRockRouteExistImgList[0]

      let wkCurrentCoordinateList = this.routeCoordinateList.filter(rt => rt.img == wkCurrentRoute.img)[0].coordinateList

      this.routeId = wkCurrentRoute.routeId
      //表示する画像とルート座標情報
      this.currentDispRouteImg = wkCurrentRoute.img
      this.currentRouteList = wkCurrentCoordinateList

      //svg上のページャー更新
      this.updateRoutePagerFlag()

      //処理に使う形式にセットしなおす
      let wkList = []
      let wkRemarkList = []

      //特記事項のセット
      wkCurrentCoordinateList.forEach(function(coordinate) {
        if(coordinate.remarks != undefined){
          wkRemarkList.push(coordinate.remarks)
        }
      })
      this.remarkList = []
      this.remarkList = wkRemarkList

      let wkFlg = false
      if(wkCurrentCoordinateList != null){
        wkFlg = true
      }

      this.isShowDrawRouteButton = wkFlg

      //カルーセルに表示する岩画像のListをセットする
      this.routeCoordinateList.forEach(function(record) {
        wkList.push({
          'img':record.img,
          'coordinateList':record.coordinateList,
          'isCurrent': wkCurrentRoute.img == record.img ? true:false
        })
      })
      this.carouselRockImgList = wkList

      this.isDataExist = true

    },
    cnvRouteName(routeName){
      return routeName == null || routeName == '' ? '（ルート名無し）' : routeName
    },
    /*--------------------------
      画像のパス生成
    --------------------------*/  
    makeImgPath(imgPath){
      if(imgPath == '' || imgPath == null){
        return
      }
      return process.env.VUE_APP_MATERIAL_URL + imgPath
    },
    makeImgThumbPath(imgPath){
      return this.getRockThumbPath(imgPath,this.rockyId,'120')
    },
    /*------------------------------
      ルートの表示、非表示を切り替える
    --------------------------------*/ 
    switchDrawRoute(){
      if(this.isShowingRouteLine){
        //既に描画済みの場合はリセットする。
        this.isShowingRouteLine = false
        //ルート線表示のListをクリアする
        this.convertedCurrentRouteList = []
        return
      }else{ 
        this.isShowingRouteLine = true
        this.dispRockImgAndRouteLine()
      }
    },
    callRouterPush(path){
      this.$router.push(path)
    },
    getButtonLabel(){

      var str = "2D表示に戻す"
      if(this.currentDispMode == this.MODE_2D){
        str =  "3D表示する"
      }

      return str
    },
    change3DFlag(){    
      //操作ログに記録する値  
      var operation = ""

      //モードに応じた処理
      if(this.currentDispMode == this.MODE_2D){
        //2D→3Dにした場合
        operation = "2D → 3D"
        localStorage.is3DModelDisp = "true"
        this.currentDispMode = this.MODE_3D
      }else{
        //3D→2Dにした場合
        operation = "3D → 2D"
        //2Dモードに戻る場合は、岩画像を幅いっぱいに表示するため、
        //handleResizeを呼び出す。
        this.handleResize()
        //ストレージ更新
        localStorage.is3DModelDisp = "false"
        this.currentDispMode = this.MODE_2D
      }

      //操作ログを登録する。
      if(this.isLogin) {
        this.postVrUserLog(operation)
      }

    },
    //操作ログ登録
    postVrUserLog(operation){
    
      var rockyId = this.rockyId
      var rockId = this.rockId
      var userAgent = navigator.userAgent

      const url = process.env.VUE_APP_API_GATEWAY + '/api-analysis/vr-user-log'
      const params = {
        rockyId: rockyId,
        rockId:rockId,
        operation:operation,
        userAgent:userAgent
      }

      // ログ登録API実行
      axios.post(url, params, {
        headers: {
          'Authorization': this.$user.idToken
        }
      })
        .then(res => {
          // 正常終了時
          // do nothing
        })
        .catch(err => {
          // エラー時
          console.log(err)
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.spinner
  height 200px
  width 100%

#route-list-container
  margin 0 0
  margin-right -15px
  margin-left -15px
  min-height 35vh

  //3D表示  
  .model-viewer-box
    display block
    width 100%
    height 350px
    background black
    .thumbnail
      width 100%
      height 100%
      position relative
      cursor pointer
      filter brightness(80%)
      &:hover
        filter brightness(90%)
        i,p
          color #007bff
          transition 0.5s
      i
        position absolute
        top 40%
        left 50%
        -ms-transform translate(-50%,-50%)
        -webkit-transform translate(-50%,-50%)
        transform translate(-50%,-50%)
        margin 0
        padding 0
        color rgba(255, 255, 255, 0.8)
        font-size 6rem
      p 
        position absolute
        top 62%
        left 50%
        -ms-transform translate(-50%,-50%)
        -webkit-transform translate(-50%,-50%)
        transform translate(-50%,-50%)
        margin 0
        padding 0
        color rgba(255, 255, 255, 1)
        font-size 2.5rem
      img
        width 100%
        height 100%
        object-fit cover
    model-viewer
      width 100%
      height 350px
      .routeLabel
        background rgba(0,0,0,0.6)
        border none
        border-radius 5px
        .routeAnnotation
          color #fff
          font-size 0.5rem
      
  #overlay-wrapper
    position absolute
    top 50vh
    left 0
    width 100%
    height 60vh
    text-align center
    background linear-gradient(to bottom, rgba(255,255,255,0), #fff 15%);
    z-index 5
    #overlay
      #info-area
        padding 1.5rem 0
        span
          font-weight 600
          color #df5f6a
      #button-area
        button
          width 100%
          margin-bottom 2rem

#rock-paging
  display flex
  justify-content space-between
  align-items center
  height 30px
  padding 10px
  font-weight 600
  font-size 1rem
  margin 2rem 0 1.5rem 0
  .pager
    cursor pointer
    color #f9f9fa
    background #dee1e3
    border-radius 30px
    padding 7px 1rem
  .isPagerActive
    color #eceeef
    background #004170
    &:active
      background #015ea1

#rock-name
  display flex
  justify-content space-between
  font-weight 600
  margin 0 1rem
  #name
    font-size 1.2rem
  #count
    padding-top 8px
    font-size 0.8rem
    color #606e79

#rock-detail
  .row
    margin-left 0
    margin-right 0

#route-info
  background #e2eff9
  color #2d8fd5
  margin 5px 0
  padding 5px
  border-radius 3px

#all-route-list
  border-top 5px solid #cfd3d7
  border-bottom 5px solid #cfd3d7
  width 100%
  overflow-y scroll
  white-space nowrap
  &::-webkit-scrollbar
    width 7px
    height 7px
  &::-webkit-scrollbar-track
    border-radius 5px
  &::-webkit-scrollbar-thumb
    border-radius 5px
    background #adb4b9
  &::-webkit-scrollbar-track
    border-radius 5px
  margin-bottom 1rem
  #list-innner
    .list-row
      min-height 38px
      width 100%
      font-size 0.9rem
      display flex
      justify-content center
      align-items center
      border-bottom solid 1px #dee1e3
      white-space pre-wrap //改行コードを有効にする
      cursor pointer
      // .list-no
      //   width 10%
      //   padding 0 1rem
      .list-route-name
        width 60%
      .list-level
        width 20%
      .list-record
      .inner-box
        width 10%
    .listRowImgNotExists
      background #ebebeb
      color #545759
      cursor auto
    .listRowActive
      background #cce4f5

#list-expansion
  margin-top -1rem
  margin-bottom 1rem
  padding-right 0.5rem
  font-size 0.8rem

#rock-img-default
  display none
//ルート画像
#rock-img
  #svg-header
    width 100%
    height 50px
    background #000
    color #fff
    font-size 1.1rem
    font-weight 600
    padding-left 10px
    display flex
    align-items center
  #rock-img-svg-container
    wicth 100%
    position relative
    #svg-wrapper      
      #srcSvg
        template
          polyline
            stroke red
        .strokeInActive, .strokeActive, .coverPolyline
          cursor pointer
        .strokeInActive
          stroke rgba(255,255,255,0.5)
          stroke-width 4

        .strokeActive
          stroke #0596ff
          stroke-width 5

        .coverPolyline
          z-index 99999

    #route-arrow-box-left
      left 0
    #route-arrow-box-right
      right 0
    #route-arrow-box-left, #route-arrow-box-right
      position absolute
      top 40%
      width 8%
      padding 5px 0px
      display flex
      .arrow
        width 40px
        height 50px
        display flex
        justify-content center
        align-items center
        z-index 100
        i
          color rgba(0,0,0,0)
          font-size 2.2rem
        .fas.fa-caret-left
          padding-right 5px
        .fa-caret-right 
          padding-left 5px

      .isRouteArrowActive
        width 100%
        cursor pointer
        background rgba(255,255,255,0.6)
        &:active
          background rgba(255,255,255,0.8)
        i
          color rgba(0,0,0,0.7)

//カルーセル
.VueCarousel
  height 65px

.VueCarousel-wrapper, .VueCarousel-inner, .VueCarousel-slide
  height 100% !important

.VueCarousel-slide .slider-inner 
  height 60px
  display flex 
  justify-content center
  align-items center
  color #fff

.VueCarousel-slide
  display flex 
  justify-content center
  align-items center
  background #374047
  margin 0 2px
  cursor pointer

.thumbnail-wrapper
  position relative
  opacity 0.7
  transition-duration 0.3s

//選択中の画像のstyle
.currentImg
  background #171d32
  img
    filter brightness(115%)

.col-12,.col-md-6
  padding: 0


#list-button-container
  margin-bottom 2rem
  #draw-route-button-area
    margin 1.5rem

// 大デバイス（デスクトップ, 1170px 以上）
@media (min-width 1170px)
  #rock-name
    padding 0
    font-weight 700
    #name
      font-size 1.5rem
    #count
      font-size 1rem

  #rock-img-default
    display block
    img
      width 100%
      height auto

  .VueCarousel-slide
    border-right 3px solid white
  
  #route-list-container
    #overlay-wrapper
      background linear-gradient(to bottom, rgba(236,238,239,0), #fff 10%);
      top 400px
      #overlay
        #button-area
          button
            width 60%

.climbKind
  font-size 0.8rem

</style>